import React from 'react';
import DsModal from '../DsModal';
import DsButton from '../DsButton';
import '../../../css/common/events/EventMembersVisibilityConfirmModal.css';

export default function EventMembersVisibilityConfirmModal({
  open = false,
  saving = false,
  nextVisible = true,
  showGroupChoices = false,
  unpublishedEventLabels = [],
  currentEventLabel = '',
  onClose,
  onConfirmGroupAll,
  onConfirmSingle,
}) {
  const actionLabel = nextVisible ? '公開する' : '非公開にする';
  const title = nextVisible ? '参加者を公開しますか？' : '参加者を非公開にしますか？';
  const description = nextVisible
    ? 'アーティストが参加者一覧を確認できるようになります。'
    : 'アーティストから参加者一覧を確認できなくなります。';

  return (
    <DsModal
      open={open}
      onClose={onClose}
      title={title}
      size="sm"
      dismissible={!saving}
      footer={showGroupChoices ? null : (
        <DsButton
          variant={nextVisible ? 'primary' : 'danger'}
          onClick={onConfirmSingle}
          loading={saving}
        >
          {actionLabel}
        </DsButton>
      )}
    >
      <p className="event-members-visibility-confirm-modal__desc">
        {showGroupChoices ? '公開する範囲を選択してください。' : description}
      </p>
      {showGroupChoices ? (
        <div className="event-members-visibility-confirm-modal__choices">
          <button
            type="button"
            className="event-members-visibility-confirm-modal__choice is-primary"
            onClick={onConfirmGroupAll}
            disabled={saving}
          >
            <span className="event-members-visibility-confirm-modal__choice-title">全公演を公開</span>
            <span className="event-members-visibility-confirm-modal__choice-note">
              未公開の公演をまとめて公開します。
            </span>
          </button>
          <button
            type="button"
            className="event-members-visibility-confirm-modal__choice"
            onClick={onConfirmSingle}
            disabled={saving}
          >
            <span className="event-members-visibility-confirm-modal__choice-title">この公演を公開</span>
            <span className="event-members-visibility-confirm-modal__choice-note">
              {currentEventLabel || 'この公演'}のみ公開します。
            </span>
          </button>
        </div>
      ) : null}
      {showGroupChoices && unpublishedEventLabels.length > 0 ? (
        <p className="event-members-visibility-confirm-modal__target">
          公開対象（未公開）: {unpublishedEventLabels.join(' / ')}
        </p>
      ) : null}
    </DsModal>
  );
}
